module.exports = __webpack_public_path__ + "static/media/xola-logo-black-small.73f500ae.png";